import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-manage-organization',
  templateUrl: './manage-organization.component.html',
  styleUrls: ['./manage-organization.component.scss']
})
export class ManageOrganizationComponent implements OnInit {

  isProcessing: boolean = false;
  searchedOrgName: any = "";
  searchedOrgShortName: any = "";
  searchedOrgId: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  resultMsg: any = "";
  searchValue1: any = "";
  organizationData: any = {};
  organizationPrivelegesData: any = {};
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  perPage3 = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private users: any[];
  pager: any = {};
  pager3: any = {};
  pagedItems: any[]; pagedItems1: any[];
  pagedItems2: any[];
  pagedItems3: any[];
  makeStickyColumns: any;
  childCheckBoxs: boolean = false;

  @ViewChild('SearchOrgpopup', { static: true }) SearchOrgpopup: TemplateRef<any>;
  visibleSearchOrgsPopup: MatDialogRef<TemplateRef<any>>;

  searchedOrgsPopupConfig = {
    width: '1000px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };
  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 2,
  };

  selectedADType: any = [];
  adListDropdown: any = [];

  constructor(public dialog: MatDialog, public appService: AppService, public router: Router, private snackBar: MatSnackBar,
    public paginationService: PaginationService, private route: ActivatedRoute, public message: messageService) {

  }
  dateFormat: any = this.appService.organizationDetails?.dateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  dateCustomClasses: DatepickerDateCustomClasses[];
  dropDownForNameFormat: any = [];
  dropDownForDateFormat: any = [];
  selectedNameFormatAtApp: any = [];
  selectedNameFormatAtRep: any = [];
  selectedDateFormat: any = [];

  selectedOrgCountries: any = [];
  orgCountriesDropdown: any = [];
  dropDownForCountry: any = [];
  ngOnInit(): void {
    this.dropDownForTimezone = JSON.parse(sessionStorage.getItem('dropDownForReportTimezone') || '{}');
    this.dropDownForCountry = JSON.parse(sessionStorage.getItem('dropDownForCountry') || '{}');
    for (let i = 0; i < this.dropDownForCountry.length; i++) {
      this.orgCountriesDropdown = this.orgCountriesDropdown.concat({
        valueExp: this.dropDownForCountry[i].codelistCode,
        displayExp: this.dropDownForCountry[i].codelistName
      });
    }
    this.isProcessing = true;
    this.appService.getNonOrgCodeListsByGroupName("USER_NAME_FORMAT").subscribe((response: any) => {
      this.isProcessing = false;
      for (let i = 0; i < response.length; i++) {
        this.dropDownForNameFormat = this.dropDownForNameFormat.concat({
          valueExp: response[i].codelistCode,
          displayExp: response[i].codelistName
        });
      }
    })
    this.isProcessing = true;
    this.appService.getNonOrgCodeListsByGroupName("DATE_FORMAT").subscribe((response: any) => {
      this.isProcessing = false;
      for (let i = 0; i < response.length; i++) {
        this.dropDownForDateFormat = this.dropDownForDateFormat.concat({
          valueExp: response[i].codelistCode,
          displayExp: response[i].codelistName
        });
      }
    })
    const now = new Date();

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  organizationsList: any = [];
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.organizationsList.length, page, this.perPage, targetpage);
    this.pagedItems1 = this.organizationsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }

  searchOrgsFunc() {
    this.isShowTabPages = false;
    this.selectedTabIndex = 0;
    this.isProcessing = true;
    this.appService.getAllOrganizations().subscribe((data: any) => {
      this.isProcessing = false;
      this.organizationsList = data;
      this.collectionSize = this.organizationsList.length;
      this.pager.totalPages = undefined;
      this.setPage1(1, 0);
      this.visibleSearchOrgsPopup = this.dialog.open(this.SearchOrgpopup, this.searchedOrgsPopupConfig);
    })
  }

  previousCheckedData: any = {};
  selectedData: any = {};
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
      this.previousCheckedData.childCheckBoxs = false;
      this.selectedData = list;
    } else {
      list.childCheckBoxs = false;
      this.selectedData = {};
    }
    this.previousCheckedData.childCheckBoxs = list;
  }

  cancelSearchOrgPopup() {
    this.visibleSearchOrgsPopup.close();
  }

  quality: Boolean;
  onTabChanged(event: any) {
    if (event.tab.textLabel == "Organization Privileges") {
      this.organizationPrivelegesData = {};
      this.isProcessing = true;
      this.appService.getOneQmsOrganizationPrivileges(this.searchedOrgId).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "E") {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",

            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        } else {
          this.organizationPrivelegesData = data
          this.organizationPrivelegesData.updateReason = "";
          this.organizationPrivelegesData.cr = this.organizationPrivelegesData.cr == "Y";
          this.organizationPrivelegesData.capa = this.organizationPrivelegesData.capa == "Y";
          this.organizationPrivelegesData.dv = this.organizationPrivelegesData.dv == "Y";
          this.organizationPrivelegesData.au = this.organizationPrivelegesData.au == "Y";
          this.organizationPrivelegesData.in = this.organizationPrivelegesData.in == "Y";
          this.organizationPrivelegesData.qi = this.organizationPrivelegesData.qi == "Y";
          this.organizationPrivelegesData.cc = this.organizationPrivelegesData.cc == "Y";
          this.organizationPrivelegesData.trn = this.organizationPrivelegesData.trn == "Y";
          this.organizationPrivelegesData.docs = this.organizationPrivelegesData.docs == "Y";
          this.organizationPrivelegesData.formsAndLogs = this.organizationPrivelegesData.formsAndLogs == "Y";
          this.organizationPrivelegesData.bp = this.organizationPrivelegesData.bp == "Y";
          this.organizationPrivelegesData.oos = this.organizationPrivelegesData.oos == "Y";
          this.quality = this.organizationPrivelegesData.cr || this.organizationPrivelegesData.capa || this.organizationPrivelegesData.dv || this.organizationPrivelegesData.au || this.organizationPrivelegesData.in || this.organizationPrivelegesData.qi || this.organizationPrivelegesData.cc || this.organizationPrivelegesData.oos;
          this.isProcessing = false;
        }
      })
    }
  }

  changeInModule(val: any) {
    if (val) {

    } else {
      this.organizationPrivelegesData.cr = false;
      this.organizationPrivelegesData.capa = false;
      this.organizationPrivelegesData.dv = false;
      this.organizationPrivelegesData.au = false;
      this.organizationPrivelegesData.in = false;
      this.organizationPrivelegesData.qi = false;
      this.organizationPrivelegesData.cc = false;
      this.organizationPrivelegesData.oos = false;
    }
  }

  selectedTabIndex: any = 0;
  filteredDropDownValueForAd: any = [];
  dropDownListForAD: any = [];
  addSearchedOrg() {
    if (this.selectedData['orgId'] == undefined) {
    } else {
      this.searchedOrgId = this.selectedData.orgId;
      this.searchedOrgName = this.selectedData.orgLongName;
      this.searchedOrgShortName = this.selectedData.orgShortName;
      this.visibleSearchOrgsPopup.close();
    }

    this.isProcessing = true;
    this.appService.getNonOrgCodeListsByGroupName("AD_TYPE").subscribe((data: any) => {
      this.dropDownListForAD = data;
      this.selectBoxForADType();
      this.isProcessing = false
      if (this.organizationData.adType != null) {
        this.filteredDropDownValueForAd = this.dropDownListForAD.filter((x: any) => x.codelistCode === this.organizationData.adType);
        if (this.filteredDropDownValueForAd.length > 0) {
          this.selectedADType = [{
            valueExp: this.filteredDropDownValueForAd[0].codelistCode,
            displayExp: this.filteredDropDownValueForAd[0].codelistName
          }]
        }
      }
      this.isProcessing = false;
    })
  }

  selectBoxForADType() {
    this.adListDropdown = [];
    for (let i = 0; i < this.dropDownListForAD.length; i++) {
      this.adListDropdown = this.adListDropdown.concat({
        valueExp: this.dropDownListForAD[i].codelistCode,
        displayExp: this.dropDownListForAD[i].codelistName
      });
    }
  }

  scrollToMinPasswordDiv: any;
  scrollToMinPassword() {
    this.scrollToMinPasswordDiv = document.getElementById('scrollToMinPassword') as HTMLInputElement;
    setTimeout(() => this.scrollToMinPasswordDiv.scrollIntoView(), 0);
  }

  isShowTabPages = false;
  dropDownForTimezone: any = [];
  hideIfDevLogin: any;
  currentDate: Date = new Date();
  licenseexpiryDateStatus: any;
  remainingDays: any;
  selectedTimeZone: any = [];
  timeZoneListDropdown: any = [];
  searchOrgWithCondition() {
    this.isProcessing = true;
    if (!this.searchedOrgName || this.searchedOrgName == "") {
      setTimeout(() => {
        this.showSnackBar("Please select the Organization Name", "E");
        this.isProcessing = false;
      }, 0);
    } else {
      let obj = {
        orgId: this.searchedOrgId,
      };
      this.organizationData = {};
      this.appService.getOneQmsOrganization(obj).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "E") {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",

            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        } else {
          this.selectedOrgCountries = [];
          this.organizationData = data;
          this.organizationData.sameEmailToMultipleUsers = this.organizationData.sameEmailToMultipleUsers == "Y";
          this.organizationData.isActive = this.organizationData.isActive == "Y";
          this.organizationData.adEnabled = this.organizationData.adEnabled == "Y";
          this.organizationData.stopEmails = this.organizationData.stopEmails == "Y";
          this.organizationData.hideUserName = this.organizationData.hideUserName == "Y";
          this.organizationData.isAllowMobileAccess = this.organizationData.isAllowMobileAccess == "Y";
          this.organizationData.isReuseDestructedDocNameAndNo = this.organizationData.isReuseDestructedDocNameAndNo == "Y";
          this.organizationData.allowUserInParallelSession = this.organizationData.allowUserInParallelSession == "Y";

          this.organizationData.updateReason = '';
          this.organizationData.inactiveReason = '';
          if (this.organizationData.licenseStartedOn != null) {
            let licenseStartedOnDateValue = new Date(this.organizationData.licenseStartedOn.split('T'));
            this.organizationData.licenseStartedOn = licenseStartedOnDateValue;
          } else {
            this.organizationData.licenseStartedOn = null;
          }

          if (this.organizationData.licenseRenewedOn != null) {
            let licenseRenewedOnDateValue = new Date(this.organizationData.licenseRenewedOn.split('T'));
            this.organizationData.licenseRenewedOn = licenseRenewedOnDateValue;
          } else {
            this.organizationData.licenseRenewedOn = null;
          }

          if (this.organizationData.licenseExpiryDate != null) {
            this.organizationData.licenseExpiryDate = new Date(this.organizationData.licenseExpiryDate);
            let expiryDateValue = new Date(this.organizationData.licenseExpiryDate);
            this.organizationData.licenseExpiryDate = expiryDateValue;
            const expiryDate = this.organizationData.licenseExpiryDate;
            expiryDate.setHours(0, 0, 0, 0);
            this.currentDate.setHours(0, 0, 0, 0);
            if (expiryDate > this.currentDate) {
              this.licenseexpiryDateStatus = "Future";
              const timeDifference = expiryDate.getTime() - this.currentDate.getTime();
              this.remainingDays = Math.ceil(timeDifference / (1000 * 3600 * 24));
            } else if (expiryDate < this.currentDate) {
              this.licenseexpiryDateStatus = "Past";
              this.licenseExpiryValidation();
            } else {
              this.licenseexpiryDateStatus = "Present";
              this.licenseExpiryValidation();
            }
          } else {
            this.licenseexpiryDateStatus = null;
            this.organizationData.licenseExpiryDate = null;
          }

          if (this.organizationData.versionUpgradedOn != null) {
            let versionUpgradedOnDateValue = new Date(this.organizationData.versionUpgradedOn.split('T'));
            this.organizationData.versionUpgradedOn = versionUpgradedOnDateValue;
          } else {
            this.organizationData.versionUpgradedOn = null;
          }

          if (data.notificationTimezone) {
            // for (let i = 0; i < this.dropDownForTimezone.length; i++) {
            //   if (this.dropDownForTimezone[i].timezone == data.notificationTimezone) {
            //     this.selectedTimeZone = [{
            //       valueExp: this.dropDownForTimezone[i].timezone,
            //       displayExp: this.dropDownForTimezone[i].timezone
            //     }]
            //   }
            // }
            const matchingTimeZone = this.dropDownForTimezone?.find((timeZone: any) => timeZone.codelistCode == data.notificationTimezone);
            if (matchingTimeZone) {
              this.selectedTimeZone = [{
                valueExp: matchingTimeZone.codelistCode,
                displayExp: matchingTimeZone.codelistName
              }]
            } else {
              this.selectedTimeZone = [];
            }
          } else {
            this.selectedTimeZone = [];
          }

          if (data.userNameFormatAtApplication) {
            for (let i = 0; i < this.dropDownForNameFormat.length; i++) {
              if (this.dropDownForNameFormat[i].valueExp == data.userNameFormatAtApplication) {
                this.selectedNameFormatAtApp = [{
                  valueExp: this.dropDownForNameFormat[i].valueExp,
                  displayExp: this.dropDownForNameFormat[i].displayExp
                }]
              }
            }
          } else {
            this.selectedNameFormatAtApp = [];
          }

          if (data.userNameFormatAtReports) {
            for (let i = 0; i < this.dropDownForNameFormat.length; i++) {
              if (this.dropDownForNameFormat[i].valueExp == data.userNameFormatAtReports) {
                this.selectedNameFormatAtRep = [{
                  valueExp: this.dropDownForNameFormat[i].valueExp,
                  displayExp: this.dropDownForNameFormat[i].displayExp
                }]
              }
            }
          } else {
            this.selectedNameFormatAtRep = [];
          }

          if (data.dateFormat) {
            for (let i = 0; i < this.dropDownForDateFormat.length; i++) {
              if (this.dropDownForDateFormat[i].valueExp == data.dateFormat) {
                this.selectedDateFormat = [{
                  valueExp: this.dropDownForDateFormat[i].valueExp,
                  displayExp: this.dropDownForDateFormat[i].displayExp
                }]
              }
            }
          } else {
            this.selectedDateFormat = [];
          }

          if (data.orgCountries) {
            let countries = data.orgCountries.split(",");
            for (let j = 0; j < countries.length; j++) {
              for (let i = 0; i < this.orgCountriesDropdown.length; i++) {
                if (this.orgCountriesDropdown[i].valueExp == countries[j]) {
                  this.selectedOrgCountries = this.selectedOrgCountries.concat({
                    valueExp: this.orgCountriesDropdown[i].valueExp,
                    displayExp: this.orgCountriesDropdown[i].displayExp
                  });
                }
              }
            }
          } else {
            this.selectedOrgCountries = [];
          }
          this.selectBoxForTimeZone();
          this.isProcessing = false;
          this.isShowTabPages = true;
        }
      }, (error) => {
        this.isProcessing = false;
      });
    }
  }

  selectBoxForTimeZone() {
    this.timeZoneListDropdown = [];
    this.timeZoneListDropdown = this.dropDownForTimezone.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  licenseExpiryDateValue: any;
  licenseExpiryDateMsg: any;
  licenseExpiryValidation() {
    this.licenseExpiryDateValue = document.getElementById("licenseExpiryDate") as HTMLInputElement;
    this.licenseExpiryDateMsg = document.getElementById('licenseExpiryDate-required-msg') as HTMLInputElement;
    if (this.licenseExpiryDateValue) {
      if (!this.licenseExpiryDateValue?.value) {
        this.licenseExpiryDateValue.style.border = '1px solid red';
        this.licenseExpiryDateValue.style.value = 'red';
        this.licenseExpiryDateMsg.style.display = 'block';
      } else {
        this.licenseExpiryDateValue.style.border = 'none';
        this.licenseExpiryDateMsg.style.display = 'none';
      }
    }
  }

  updateReasonValue: any;
  minimumPasswordValue: any;
  inactiveReason: any;
  updateReasonRequiredMsg: any;
  updateReasonMessageDisplayed: any;
  inactiveReasonRequiredMsg: any;
  minimumPasswordInvalidMessage: any;
  minimumPasswordMessageDisplayed: any;
  onFieldFocusout() {
    if (this.updateReasonMessageDisplayed) {
      this.updateReasonValue.style.border = 'none';
      this.updateReasonRequiredMsg.style.display = 'none';
    }
    this.updateReasonMessageDisplayed = false;
  }

  resetData() {
    this.isShowTabPages = false;
    this.organizationData = {};
    this.searchedOrgId = null;
    this.searchedOrgName = "";
    this.searchedOrgShortName = "";
  }

  fieldValidation() {
    this.updateReasonValue = document.getElementById('updateReason') as HTMLInputElement;
    this.minimumPasswordValue = document.getElementById('minimumPasswordLength') as HTMLInputElement;
    this.inactiveReason = document.getElementById('inactiveReason') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;
    this.minimumPasswordInvalidMessage = document.getElementById('minimumpassword-invalid-msg') as HTMLInputElement;
    this.inactiveReasonRequiredMsg = document.getElementById('inactiveReason-invalid-msg') as HTMLInputElement;

    if (this.organizationData.updateReason == '') {
      this.updateReasonMessageDisplayed = true;
      this.updateReasonValue.style.border = '1px solid red';
      this.updateReasonRequiredMsg.style.display = 'block';
    } else {
      this.updateReasonValue.style.border = 'none';
      this.updateReasonRequiredMsg.style.display = 'none';
    }


    if (this.organizationData.minimumPasswordLength && this.organizationData.minimumPasswordLength < 8) {
      this.minimumPasswordMessageDisplayed = true;
      this.scrollToMinPassword();
      this.minimumPasswordValue.style.border = '1px solid red';
      this.minimumPasswordInvalidMessage.style.display = 'block';
    } else {
      this.minimumPasswordValue.style.border = 'none';
      this.minimumPasswordInvalidMessage.style.display = 'none';
    }

    if (this.isShowInactiveReason) {
      if (this.organizationData.inactiveReason == '' || this.organizationData.inactiveReason == null) {
        this.inactiveReason.style.border = '1px solid red';
        this.inactiveReasonRequiredMsg.style.display = 'block';
      } else {
        this.inactiveReason.style.border = 'none';
        this.inactiveReasonRequiredMsg.style.display = 'none';
      }
    }

  }

  fieldValidation1() {
    if (!this.organizationData.updateReason) {
      this.updateReasonValue = document.getElementById('updateReason1') as HTMLInputElement;
      this.updateReasonRequiredMsg = document.getElementById('updateReason1-required-msg') as HTMLInputElement;

      if (this.organizationPrivelegesData.updateReason == '') {
        this.updateReasonMessageDisplayed = true;
        this.updateReasonValue.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
      } else {
        this.updateReasonValue.style.border = 'none';
        this.updateReasonRequiredMsg.style.display = 'none';
      }
    }

    if (!this.organizationPrivelegesData.topicNoOfDaysAtHome) {
      const field = document.getElementById('topic') as HTMLInputElement;
      field.style.color = 'red';
    }

  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. [onNgModuleChange()] Id → ', fieldId);
  }


  updateOneQmsOrganization(organizationData: any) {
    this.isProcessing = true;
    if (this.organizationData.updateReason == '' || (this.organizationData.minimumPasswordLength && this.organizationData.minimumPasswordLength < 8)
      || (this.isShowInactiveReason && this.organizationData.inactiveReason == '')) {
      this.isProcessing = false;
      this.fieldValidation();
    } else {
      if (this.minimumPasswordMessageDisplayed) {
        this.minimumPasswordValue.style.border = 'none';
        this.minimumPasswordInvalidMessage.style.display = 'none';
        this.minimumPasswordMessageDisplayed = false;
      }
      delete organizationData.createdOn;
      delete organizationData.updatedOn;
      let orgCountries = null;
      for (let i = 0; i < this.selectedOrgCountries.length; i++) {
        orgCountries = orgCountries == null ? this.selectedOrgCountries[i].valueExp : orgCountries + "," + this.selectedOrgCountries[i].valueExp;
      }
      let data = {
        ...organizationData,
        orgId: this.searchedOrgId,
        parentOrgShortName: this.searchedOrgShortName,
        sameEmailToMultipleUsers: organizationData.sameEmailToMultipleUsers ? "Y" : "N",
        isAdAuthenticationForcedAtApprovals: organizationData.isAdAuthenticationForcedAtApprovals ? "Y" : "N",
        isAdAuthenticationForcedAtLogin: organizationData.isAdAuthenticationForcedAtLogin ? "Y" : "N",
        isActive: organizationData.isActive ? "Y" : "N",
        adEnabled: organizationData.adEnabled ? "Y" : "N",
        stopEmails: organizationData.stopEmails ? "Y" : "N",
        hideUserName: organizationData.hideUserName ? "Y" : "N",
        isAllowMobileAccess: organizationData.isAllowMobileAccess ? "Y" : "N",
        isReuseDestructedDocNameAndNo: organizationData.isReuseDestructedDocNameAndNo ? "Y" : "N",
        licenseStartedOn: organizationData.licenseStartedOn ? this.appService.dateZoneConvertion(new Date(organizationData.licenseStartedOn)) : null,
        licenseRenewedOn: organizationData.licenseRenewedOn ? this.appService.dateZoneConvertion(new Date(organizationData.licenseRenewedOn)) : null,
        licenseExpiryDate: organizationData.licenseExpiryDate ? this.appService.dateZoneConvertion(new Date(organizationData.licenseExpiryDate)) : null,
        versionUpgradedOn: organizationData.versionUpgradedOn ? new Date(organizationData.versionUpgradedOn) : null,
        adType: this.selectedADType[0]?.valueExp ?? null,
        notificationTimezone: this.selectedTimeZone[0]?.valueExp ?? null,
        userNameFormatAtApplication: this.selectedNameFormatAtApp[0]?.valueExp ?? null,
        userNameFormatAtReports: this.selectedNameFormatAtRep[0]?.valueExp ?? null,
        dateFormat: this.selectedDateFormat[0]?.valueExp ?? null,
        allowedFileExtns: organizationData.allowedFileExtns,
        allowedFileSizeInMb: organizationData.allowedFileSizeInMb,
        allowUserInParallelSession: organizationData.allowUserInParallelSession ? "Y" : "N",
        orgCountries: orgCountries,
        updateCriteria: "primary" /* Prime access to edit everything */
      }

      this.appService.updateOneQmsOrganization(data).subscribe((Response: any) => {
        this.displayMessage = Response.result;
        this.displayResultType = Response.resultType;
        if (this.displayResultType == 'S') {

        }
        this.isProcessing = false;
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok",

          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }
  }

  updateOneQmsOrganizationPriv(organizationPrivData: any) {
    this.isProcessing = true;
    if (this.organizationPrivelegesData.updateReason == '' || !this.organizationPrivelegesData.topicNoOfDaysAtHome) {
      this.isProcessing = false;
      this.showSnackBar("Please enter all mandatory fields", 'E');
      this.fieldValidation1();
    } else {
      delete organizationPrivData.createdOn;
      delete organizationPrivData.updatedOn;

      let data = {
        ...organizationPrivData,
        orgId: this.searchedOrgId,
        in: organizationPrivData.in ? "Y" : "N",
        qi: organizationPrivData.qi ? "Y" : "N",
        cr: organizationPrivData.cr ? "Y" : "N",
        capa: organizationPrivData.capa ? "Y" : "N",
        dv: organizationPrivData.dv ? "Y" : "N",
        au: organizationPrivData.au ? "Y" : "N",
        docs: organizationPrivData.docs ? "Y" : "N",
        formsAndLogs: organizationPrivData.formsAndLogs ? "Y" : "N",
        trn: organizationPrivData.trn ? "Y" : "N",
        cc: organizationPrivData.cc ? "Y" : "N",
        oos: organizationPrivData.oos ? "Y" : "N",
        bp: organizationPrivData.bp ? "Y" : "N",
      }

      this.appService.updateOneQmsOrganizationPriv(data).subscribe((Response: any) => {
        this.displayMessage = Response.result;
        this.displayResultType = Response.resultType;
        if (this.displayResultType == 'S') {

        }
        this.isProcessing = false;
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok",

          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }
  }

  minRenewedDate = new Date();
  minExpiryDate = new Date();
  todayDate = new Date();
  setVal(startDate: Date) {
    this.minRenewedDate.setDate(startDate.getDate() + 1);
    this.minRenewedDate.setMonth(startDate.getMonth());
    this.minRenewedDate.setFullYear(startDate.getFullYear());
    this.minExpiryDate.setDate(startDate.getDate() + 1);
    this.minExpiryDate.setMonth(startDate.getMonth());
    this.minExpiryDate.setFullYear(startDate.getFullYear());
  }

  setVal1(renewedDate: Date) {
    this.minExpiryDate.setDate(renewedDate.getDate() + 1);
    this.minExpiryDate.setMonth(renewedDate.getMonth());
    this.minExpiryDate.setFullYear(renewedDate.getFullYear());
  }

  isShowInactiveReason: boolean = false;
  checkInactiveFunc(val: any) {
    if (val) {
      this.isShowInactiveReason = false;
    } else {
      this.isShowInactiveReason = true;
    }
  }

  onCheckboxChange(event: MatSlideToggleChange) {
    [
      this.selectedADType,
      this.organizationData.talentId,
      this.organizationData.clientId,
      this.organizationData.isAdAuthenticationForcedAtLogin,
      this.organizationData.isAdAuthenticationForcedAtApprovals
    ] = [[], '', '', false, false];
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: '',
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  formatBytes(mb: number): string {
    const bytes = mb * 1024 * 1024;
    return new Intl.NumberFormat('en-US').format(bytes);
  }

  onSizeInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = Number(input.value);

    if (Number.isNaN(value)) {
      input.value = '';
      return;
    }

    if (value < 5) {
      input.value = '5';
    } else if (value > 5120) {
      input.value = '5120';
      this.showSnackBar('Max is 5120 MB which is 5 GB', 'E')
    }

    this.organizationData.allowedFileSizeInMb = Number(input.value);
  }

  onTimeoutInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = Number(input.value);

    if (Number.isNaN(value)) {
      input.value = '';
      return;
    }

    if (value < 1) {
      input.value = '1';
    } else if (value > 60) {
      input.value = '60';
      this.showSnackBar('Max is 60 minutes', 'E')
    }

    this.organizationData.userSessionTimeoutInMins = Number(input.value);
  }
}
